import { fontSize, fontWeight, theme } from "@tm/utility/global";
import styled from "styled-components";

export {
  CloseButton,
  Overlay,
  SheetHeader,
  SheetPanel,
  SheetTitle,
} from "../sheet.style";

export const SectionsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 12px;
  overflow-y: auto;
`;

export const StatusInfoCard = styled.div`
  background: ${theme.lightBlueBg};
  border-radius: 16px;
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 6px;

  p {
    margin: 0;
  }
`;

export const StatusInfoTitle = styled.div`
  font-size: ${fontSize.font16};
  font-weight: ${fontWeight.bold};
  color: ${theme.blackText};
  line-height: 1.4;
`;

export const StatusInfoDescription = styled.div`
  font-size: ${fontSize.font14};
  font-weight: ${fontWeight.regular};
  color: ${theme.greyText};
  line-height: 1.6;

  p + p {
    margin-top: 8px;
  }

  b,
  strong {
    font-weight: ${fontWeight.bold};
    color: ${theme.blackText};
  }
`;

export const StatusInfoFootnote = styled.div`
  font-size: ${fontSize.font12};
  color: ${theme.greyText3};
  line-height: 1.5;
`;

export const Divider = styled.div`
  height: 1px;
  width: 100%;
  background: ${theme.gainsBoro};
`;

export const DetailInfoList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const DetailInfoRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
`;

export const DetailInfoLabel = styled.span`
  flex: 0 0 43%;
  font-size: ${fontSize.font16};
  font-weight: ${fontWeight.regular};
  color: ${theme.greyText};
`;

export const DetailInfoValue = styled.span`
  flex: 1;
  font-size: ${fontSize.font16};
  font-weight: ${fontWeight.bold};
  color: ${theme.blackText};
  text-align: left;
  word-break: break-word;
`;

export const DocumentsValue = styled.span`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const DocumentRow = styled.span`
  font-size: ${fontSize.font16};
  font-weight: ${fontWeight.bold};
  color: ${theme.blueText};
  word-break: break-word;
`;
